<script lang="ts">
  import {ResiPlaylist, ResiVideo} from '@/types/integrations';
  import {createEventDispatcher} from 'svelte';
  import dayjs from 'dayjs';

  export let item: ResiPlaylist | ResiVideo;

  const isPlaylists = (item: ResiPlaylist | ResiVideo): item is ResiPlaylist => {
    return 'name' in item;
  };

  const name = isPlaylists(item) ? item.name : item.title;
  const dispatch = createEventDispatcher<{
    click: string;
  }>();

  const handleClick = (id: string) => {
    dispatch('click', id);
  };
</script>

<li>
  <div class="flex w-52 flex-col items-center gap-3 rounded-xl bg-white p-4">
    <img src={item.thumbnail?.url} alt={name} class="h-32 w-full rounded-lg object-cover" loading="lazy" />

    <div class="flex w-full flex-col text-left">
      <div class="text-sm font-bold text-sermon-base">{name}</div>
      {#if !isPlaylists(item)}
        <div class="text-xs text-gray-500">
          {dayjs(item.airDate).format('MMM DD, YYYY')}
        </div>
      {/if}
    </div>

    <button
      class="btn btn-secondary w-full text-sm"
      tabindex="0"
      aria-label={`Browse playlist: ${name}`}
      on:click={() => handleClick(isPlaylists(item) ? item.id : item.contentUrls[0].hls)}
      type="button"
    >
      {isPlaylists(item) ? 'Browse' : 'Upload Video'}
    </button>
  </div>
</li>
